export default __webpack_public_path__ + "static/media/0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56.488237bc.svg";